import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * Get all projects for Livestream
 */
export async function getStreamToken(projectId) {
    if (isAuthenticated()) {
        const headers = {
            'Content-Type': 'application/json',
        };
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/stream/${projectId}`,
            {
                method: 'GET',
                headers: headers,
            }
        );

        return await response.json();
    } else return null;
}
